import { CanChuyen } from "../../restapi/canChuyen";
import { ContactsApi } from "../../restapi/contactsApi";
import { GetMienCuPhapID } from "../../utils/common";
import { Dexiedb } from "../Dexiedb";
import { globalDexieDb } from "../DexiedbLib";
import { ICanChuyenParamGroup } from "../model/canChuyenParamGroup";
import { IContactsConfig } from "../model/contactConfig";
import { IContactGiaThuong } from "../model/contactGiaThuong";
import { INgoaiLe } from "../model/ngoaiLe";
import { ApiResult } from "../report/localBackend";

export async function DownloadContactGiaThuongByContact(param: any): Promise<number> {
    //const {contactId,mienCuPhapId}= param;
    const res: any = await ContactsApi.getContactGiaThuong(param)

    const db = globalDexieDb;
    const data: IContactGiaThuong[] = res.data.data.giaThuong;
    const config: IContactsConfig[] = res.data.data.config;

    await db.contactGiaThuong.bulkPut(data)
    await db.contactsConfig.bulkPut(config)
    return data.length + config.length;
}
async function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export async function DownloadAllContactGiaThuong(): Promise<ApiResult> {
    console.log("DownloadAllContactGiaThuong start", new Date().toLocaleString())
    const db = globalDexieDb;
    const mienCuPhapId = GetMienCuPhapID();
    const result: any = await ContactsApi.getContactsList()
    await db.contacts.clear();
    await db.contacts.bulkPut(result.data.data)
    console.log("DownloadAllContactGiaThuong xong contacts", new Date().toLocaleString())
    //const contacts = result?.data

    const contacts = await db.contacts.toArray()
    let totalRecords = 0;
    for (const contact of contacts) { // các hàm async, muốn tuần tự phải dùng for kiểu này
        const param = [contact.contactId, mienCuPhapId]
        totalRecords += await DownloadContactGiaThuongByContact(param);
        console.log("DownloadContactGiaThuongByContact", contact.contactId)
        const paramCC = { contactId: contact.contactId }
        await sleep(100);
        totalRecords += await DownloadCanChuyenParams(paramCC);
        console.log("DownloadCanChuyenParams", contact.contactId)
        await sleep(100);
    }
    // download tham số cân chuyển
    console.log("DownloadAllContactGiaThuong done", new Date().toLocaleString())
    const response: ApiResult = {
        responseText: "Hoàn thành tải dữ liệu để làm việc cục bộ: " + totalRecords + " bản ghi",
        errorCode: 0,
        data: null,
        dataEx: null,
    }
    return response

}
export async function DownloadAllContactGiaThuongByContact(contactId: number): Promise<ApiResult> {
    console.log("DownloadAllContactGiaThuong start", new Date().toLocaleString())
    const db = globalDexieDb;
    const mienCuPhapId = GetMienCuPhapID();
    const result: any = await ContactsApi.getContactsList()
    await db.contacts.clear();
    await db.contacts.bulkPut(result.data.data)
    console.log("DownloadAllContactGiaThuong xong contacts", new Date().toLocaleString())
    //const contacts = result?.data

    const contacts = await db.contacts.where("contactId").equals(contactId).toArray()
    let totalRecords = 0;
    for (const contact of contacts) { // các hàm async, muốn tuần tự phải dùng for kiểu này
        const param = [contact.contactId, mienCuPhapId]
        totalRecords += await DownloadContactGiaThuongByContact(param);
        console.log("DownloadContactGiaThuongByContact", contact.contactId)
        const paramCC = { contactId: contact.contactId }
        await sleep(100);
        totalRecords += await DownloadCanChuyenParams(paramCC);
        console.log("DownloadCanChuyenParams", contact.contactId)
        await sleep(100);
    }
    // download tham số cân chuyển
    console.log("DownloadAllContactGiaThuong done", new Date().toLocaleString())
    const response: ApiResult = {
        responseText: "Hoàn thành tải dữ liệu để làm việc cục bộ: " + totalRecords + " bản ghi",
        errorCode: 0,
        data: null,
        dataEx: null,
    }
    return response

}
async function DownloadCanChuyenParams(paramCC: any): Promise<number> {
    const ccparam = await CanChuyen.getCanChuyenParamGroupsAll(paramCC)
    for (let row of ccparam.data.canChuyenParamGroup) {
        globalDexieDb.canChuyenParamGroup.put(row);
    }
    const ngoaiLe: INgoaiLe = { contactId: paramCC.contactId, json: ccparam.data.json }
    globalDexieDb.ngoaiLe.put(ngoaiLe);
    return ccparam.data.canChuyenParamGroup.length;
}
export async function SaveContactGiaThuong(params: any) {
    const db = globalDexieDb;
    if (!params)
        return
    db.contactGiaThuong.bulkPut(params)
}
export async function SaveContactConfig(params: any) {
    const db = globalDexieDb;
    if (!params)
        return
    db.contactsConfig.bulkPut(params)
}